<template>
  <div :class="{'hideleft':hide === true}" class="page">
    <div class="crumb-container">
      <ol class="breadcrumb">
        <li>
          <a href="javascript:;" class="crumb-home z-font-size-14">产品</a>
        </li>
        <li>
          <a href="javascript:;" class="z-font-size-14">我的物理机</a>
        </li>
      </ol>
    </div>
    <div class="page-main z-padding-h-20-precent">
      <div class="panel-heading">
        <div class="se-panel-title">高防物理机列表</div>
      </div>
      <div class="panel-body clearfix">
        
        <el-table :data="physicalList" highlight-current-row show-header v-loading="listLoading" class="table-empty" style="width: 100%;">
          <el-table-column prop="ip" label="IP" align="left">            
          </el-table-column>
          <el-table-column prop="data_center" label="数据中心" align="left">           
          </el-table-column>
          <el-table-column prop="gf_level" label="防御级别" align="left">
          </el-table-column>
          <el-table-column prop="net_width" label="带宽" align="left">            
          </el-table-column>
          <el-table-column prop="cpu" label="CPU" align="left" width="200">            
          </el-table-column>
          <el-table-column prop="disk_size" label="硬盘" align="left">            
          </el-table-column>
          <el-table-column prop="memory_size" label="内存" align="left">           
          </el-table-column>
          <el-table-column prop="StartTime" label="开始时间" align="left">            
          </el-table-column>
          <el-table-column prop="EndTime" label="结束时间" align="left">
          </el-table-column>
          <el-table-column prop="price" label="价格" align="left">
          </el-table-column>
          <el-table-column prop="cost_type" label="操作" align="center">
            <template slot-scope="scope">
              <router-link :to="'/physical'+'/'+scope.row.id" class="z-color-a">管理</router-link>
              &nbsp;&nbsp;
              <el-button type="primary" @click="Rennew(scope.row.ip)">续费</el-button>
            </template>
          </el-table-column>
          <span slot="empty">
            高防物理机列表为空，
            <a class="z-curPonit z-color-a" href="/gfServer/" target="_blank">立即购买&gt;&gt;</a>
          </span>
        </el-table>
        <el-pagination background layout="total, sizes" :page-sizes="[10, 20, 30, 50]" @size-change="handleSizeChange" :page-size="10" :total="total" class="pull-left">
        </el-pagination>
        <el-pagination background layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="count" :total="total">
        </el-pagination>
      </div>
    </div>
    <xdialog-loading :dialogLoading="dialogLoading"></xdialog-loading>
  </div>
</template>
<script>
  import { MessageBox } from 'element-ui';
  import XdialogLoading from 'components/commons/XdialogLoading.vue'
  import userService from 'business/userService.js'
  import renewService from 'business/renewService.js'
  export default {
    data () {
      return {
        physicalList:[],
        dialogLoading:false,
        listLoading:false,
        showempty:false,
        count:10,
        total:0,
        page:1,
      }
    },
    components:{
      XdialogLoading,
    },
    props:{
      hide:Boolean
    },
    mounted() {
      this.SearchPhysical()
    },
    methods:{
      async SearchPhysical() {
        this.listLoading = true
        let data = 'cmd=gf_wuliji'+
          '&count='+ this.count +
          '&page='+ this.page
        let {vueData, state} = await userService.transformToVue('userInfo','POST',data)
        if(vueData.response == 200 ) {
          this.total = vueData.msg.allcount
          this.physicalList = vueData.msg.content
          this.showempty = true
          this.listLoading = false
        }else {
          this.$toast(vueData.msg,'fail')
        }
      },
      handleCurrentChange(val) {
        this.page = val;
        this.SearchPhysical()
      },
      handleSizeChange(val) {
        this.count = val
        this.SearchPhysical()
      },
      Rennew(ip) {
        MessageBox.confirm('续费将扣款，是否续费？', '续费', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          lockScroll: false,
          type: 'warning'
        }).then(async() => {
          this.dialogLoading = true
          let data = 'cmd=xufei_wuliji'+
            '&ip='+ ip
          let {vueData, state} = await userService.transformToVue('userInfo','POST',data)
          if(vueData.response == 200 ) {
            this.dialogLoading = false
            let self = this
            this.$dialog({type:'success', info: vueData.msg, click () {self.SearchPhysical()}})
          }else {
            this.dialogLoading = false
            this.$dialog({type:'error', info: vueData.msg, click () {}})
          }
        }).catch(() => {

        });
      },
    }
  }
</script>
<style scoped>
  .page {
    margin-top: 45px;
    width: 100%;
  }
  .hideleft { margin-left: 80px; }
  .xufei-form .el-input,.el-select {
    width: 140px;
  }
  .input-with-select .el-input-group__prepend .el-select {
    width: 100px;
  }
  .ver-sub { vertical-align: sub; }
  .alert-warn {
    margin-bottom: 20px;
  }
  .alert-warn.alert-white-bg {
    border: none;
    padding: 0px;
    background: #fff;
    line-height: 2em;
    color: #aaa;
  }
  .alert-warn.alert-white-bg .alert-warn-title {
    color: #ff8800;
  }
  .vhost-free {
    position: absolute;
    right: 26%;
    top: 30%;
    display: inline-block;
    width: 29px;
    height: 23px;
    background: url(../../assets/imgs/free.gif) no-repeat center;
  }
</style>




// WEBPACK FOOTER //
// src/pages/product/physicalList.vue